import aiServer from '@assets/images/solution/recommendation/mobile/aiServer.avif';
import co2 from '@assets/images/solution/recommendation/mobile/co2.avif';
import edgeRtls from '@assets/images/solution/recommendation/mobile/edgeRtls.avif';
import fisheye from '@assets/images/solution/recommendation/mobile/fisheye.avif';
import idCard from '@assets/images/solution/recommendation/mobile/idCard.avif';
import ipCamera from '@assets/images/solution/recommendation/mobile/ipCamera.avif';
import loraGateway from '@assets/images/solution/recommendation/mobile/loraGateway.avif';
import nvr from '@assets/images/solution/recommendation/mobile/nvr.avif';
import patientTag from '@assets/images/solution/recommendation/mobile/patientTag.avif';
import ptz from '@assets/images/solution/recommendation/mobile/ptz.avif';
import safeCradle from '@assets/images/solution/recommendation/mobile/safeCradle.avif';
import safeTag from '@assets/images/solution/recommendation/mobile/safeTag.avif';
import safetyBell from '@assets/images/solution/recommendation/mobile/safetyBell.avif';
import server from '@assets/images/solution/recommendation/mobile/server.avif';
import slimTag from '@assets/images/solution/recommendation/mobile/slimTag.avif';
import stickerTag from '@assets/images/solution/recommendation/mobile/stickerTag.avif';
import switchImg from '@assets/images/solution/recommendation/mobile/switch.avif';
import twintrackerUwb from '@assets/images/solution/recommendation/mobile/twintrackerUwb.avif';
import uwbTag from '@assets/images/solution/recommendation/mobile/uwbTag.avif';
import plutoconPro from '@assets/images/solution/recommendation/mobile/plutoconPro.avif';
import twintrackerBLE from '@assets/images/solution/recommendation/mobile/twintrackerBle.avif';

export default {
  ipCamera: {
    title: 'IP Camera',
    desc: 'An IP Camera is a digital CCTV that transmits video data over a network via the Internet Protocol. It offers easy installation, remote monitoring, and video storage, making it widely used for security, safety, and operational management.',
    img: ipCamera,
    link: '/camera/edge',
  },
  ptzCamera: {
    title: 'PTZ Camera',
    desc: 'A PTZ (Pan-Tilt-Zoom) Camera is a high-performance CCTV with remote-controlled pan, tilt, and optical zoom functions. It enables efficient monitoring of wide areas with a single device.',
    img: ptz,
    link: '/camera/edge',
  },
  fisheyeCamera: {
    title: 'Fisheye Camera',
    desc: 'A Fisheye Camera uses an ultra-wide-angle lens (over 180°) to capture a wide area with one device. Despite the distortion, it provides comprehensive, blind-spot-free monitoring.',
    img: fisheye,
    link: '/camera/edge',
  },
  co2: {
    title: 'CO₂ Detector',
    desc: 'A CO₂ detector continuously monitors CO₂ levels in the air, sounding an alarm and providing visual alerts when thresholds are reached. It runs on battery or external power—essential for field safety management.',
    img: co2,
    link: '/iot/co2',
  },
  server: {
    title: 'ORBRO Server',
    desc: 'The ORBRO Server is a central platform that integrates data from RTLS, CCTV, sensors, and more. It provides real-time analytics, reporting, alerts, and seamless API integration with enterprise systems.',
    img: server,
    link: '/os/server',
  },
  aiServer: {
    title: 'ORBRO AI Server',
    desc: 'The ORBRO AI Server analyzes video and sensor data in real time on-site, automatically detecting anomalies and delivering alerts and reports immediately without network delay. It is an intelligent edge-AI analysis server.',
    img: aiServer,
    link: '/camera/server',
  },
  nvr: {
    title: 'NVR',
    desc: 'A Network Video Recorder (NVR) receives and stores video from cameras over the network. It supports multi-camera recording, real-time monitoring, and search functions—ideal for digital video storage.',
    img: nvr,
    link: '/camera/server',
  },
  twintrackerUWB: {
    title: 'TwinTracker UWB',
    desc: 'TwinTracker UWB is an ultra-wideband-based location-tracking reader that receives UWB signals and computes precise locations within ±10 cm. It supports multi-tag tracking and delivers stable real-time location data even in complex spaces.',
    img: twintrackerUwb,
    link: '/rtls/uwb',
  },
  twintrackerBLE: {
    title: 'TwinTracker BLE',
    desc: 'TwinTracker BLE is an indoor location-tracking reader using low-energy Bluetooth signals to track tag locations by zone. Easy to install and operate, it is ideal for managing large numbers of assets or people indoors.',
    img: twintrackerBLE,
    link: '/rtls/uwb',
  },
  uwbTag: {
    title: 'UWB Tag',
    desc: 'A UWB Tag attaches to people or equipment and allows real-time location tracking with ±10 cm accuracy. It is rugged, waterproof, low-power, and suitable for extended use.',
    img: uwbTag,
    link: '/rtls/uwb',
  },
  stickerTag: {
    title: 'Sticker Tag',
    desc: 'Sticker Tag is a ultra-compact, easy-to-attach tag for assets. It collects movement history and supports real-time tracking. Lightweight and low-power, it fits various logistics and manufacturing scenarios.',
    img: stickerTag,
    link: '/rtls/uwb',
  },
  slimTag: {
    title: 'Slim Tag',
    desc: 'Slim Tag is a BLE-based, ultra-slim card-style tag that fits easily in a uniform pocket or on asset surfaces. Lightweight and low-power, it is ideal for indoor personnel and asset tracking.',
    img: slimTag,
    link: '/rtls/uwb',
  },
  edgeRtls: {
    title: 'ORBRO Edge RTLS',
    desc: 'ORBRO Edge RTLS is an edge device that processes tag signals on-site in real time to compute locations, operating independently with ultra-low latency—no cloud required.',
    img: edgeRtls,
    link: '/os/rtls',
  },
  edgeAi: {
    title: 'ORBRO Edge AI',
    desc: 'ORBRO Edge AI is an edge device that processes tag signals on-site in real time to compute locations, operating independently with ultra-low latency—no cloud required.',
    img: edgeRtls,
    link: '/os/rtls',
  },
  switch: {
    title: 'L2 PoE Switch',
    desc: 'An L2 PoE switch delivers both power and data via Ethernet cable. It efficiently connects devices like IP cameras, UWB anchors, BLE readers—streamlining wiring and boosting network efficiency.',
    img: switchImg,
    link: '/os/switch',
  },
  plutoconPro: {
    title: 'Plutocon Pro',
    desc: 'Plutocon Pro is an industrial-grade BLE beacon with powerful signal transmission. It offers stable indoor positioning over long distances, waterproof/dustproof design, and battery-replaceable structure—optimized for logistics, manufacturing, and asset tracking.',
    img: plutoconPro,
    link: '/rtls/ble',
  },
  safeTag: {
    title: 'Safe Tag',
    desc: 'Safe Tag attaches to display devices (phones, tablets) and instantly detects removal, separation, vibration, or other anomalies—sending alerts immediately. It is a dedicated security tag.',
    img: safeTag,
    link: '/os/rtls',
  },
  safetyBell: {
    title: 'Safety Bell',
    desc: 'Safety Bell is a safety aid that provides instant audible and visual alerts in emergencies. Wirelessly integrated into the system, it enhances overall field safety response.',
    img: safetyBell,
    link: '/os/rtls',
  },
  safeCradle: {
    title: 'Safe Cradle',
    desc: 'The Safe Cradle is a dedicated stand that holds both the Safe Tag and display device. It provides power, wireless communication, and security detection. With anti-tamper design and precise docking angle, it immediately triggers alerts if the tag is removed, vibrated, or separated.',
    img: safeCradle,
    link: '/os/rtls',
  },
  loraGateway: {
    title: 'LoRa Gateway',
    desc: 'A LoRa Gateway is a network hub based on LoRaWAN protocol that supports long-range communication. It reliably gathers data from distant sensors or tags and forwards it to edge servers or the cloud.',
    img: loraGateway,
    link: '/os/rtls',
  },
  patientTag: {
    title: 'Patient Tag',
    desc: 'The Patient Tag is a low-power UWB/BLE wearable tag for healthcare. It safely tracks patient location in real time in hospitals, triggering automatic alerts on zone exit or emergencies for rapid response.',
    img: patientTag,
    link: '/rtls/ble',
  },
  idCard: {
    title: 'ID Card',
    desc: 'The ID Card (employee badge) is used for identity verification and access control. It features a durable plastic badge with embedded BLE chip, offering fast and secure contactless authentication.',
    img: idCard,
    link: '/rtls/ble',
  },
};
